module.exports = __webpack_public_path__ + "static/media/6d80c9ff-73a2-333d-cf58-b793bd3396cb.749a93a7.jpg";